import { render, staticRenderFns } from "./StructureModal.vue?vue&type=template&id=656e99a2&scoped=true&"
import script from "./StructureModal.vue?vue&type=script&lang=js&"
export * from "./StructureModal.vue?vue&type=script&lang=js&"
import style0 from "./StructureModal.vue?vue&type=style&index=0&id=656e99a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656e99a2",
  null
  
)

export default component.exports